import { render, staticRenderFns } from "./InvoiceReport.vue?vue&type=template&id=820c39a4&scoped=true"
import script from "./InvoiceReport.vue?vue&type=script&lang=js"
export * from "./InvoiceReport.vue?vue&type=script&lang=js"
import style0 from "./InvoiceReport.vue?vue&type=style&index=0&id=820c39a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820c39a4",
  null
  
)

export default component.exports